import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const speed = new Quantity(
    quantityId.SPEED,
    'Speed'
);

// todo - switch to proper SI base unit m/s
speed.registerUnit(
    new Unit(
        'kmh', 3.6, 'kilometre per hour', [
            'km/h', 'kmph'
        ]
    )
);

speed.registerUnit(
    new Unit(
        'mps', 1, 'metre per second', [
            'm/s'
        ]
    )
);

speed.registerUnit(
    new Unit(
        'miph', 3600 * 0.00062137119223733, 'mile per hour', [
            'mph', 'MPH', 'miph'
        ]
    )
);

export default speed;